import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { purple } from '@mui/material/colors';

const TextButtonLight = styled(Button)(({ theme }) => ({
  color: '#fff',
  fontWeight: 'bold',
  letterSpacing: '3px',
  fontWeight: 700,
  fontSize: '12px',
  paddingLeft: '30px',
  paddingRight: '30px',
  '&:hover': {
    backgroundColor: 'var(--dark-blue)',
    color: 'var(--dark-blue)',
  },
  '&.MuiButton-textSizeLarge': {
    paddingBottom: '12px',
    paddingTop: '12px',
  },
}));

export default TextButtonLight;
